import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=5b638ebd&scoped=true"
import script from "./Upload.vue?vue&type=script&setup=true&lang=js"
export * from "./Upload.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b638ebd",
  null
  
)

export default component.exports